<div class="container section">

    <div class="row pagetitle-row">
        <div class="pagetitle">
            <div class="nav-icons checkout"></div>
            <h1 class="checkout">Summary and Checkout</h1>
        </div>
    </div>


    <!-- <pre>
        <table>
            <tr>
                <td>
                    <code *ngIf="orderdetails">
                        {{orderdetails | json}}    
                       </code>
                </td>
                <td>
                    <code *ngIf="gresOptions">
                        {{gresOptions[0].OrderDetails | json}}    
                       </code>
                </td>
                <td> 
                    <code *ngIf="gresOptions">
                    {{gresOptions[1].OrderDetails | json}}    
                   </code>                    
                </td>
            </tr>
        </table>   
</pre> -->


    <div id="contentwrap" class="FlowupLabels">
        <div id="content" class="acepCart">

            <form class="full-width" novalidate>

                <div class="row membership-items" *ngIf="orderdetails.orderLineItems">
                    <h3>Membership</h3>
                    <div class="row header-row">
                        <div class="col-xs-8">Description</div>
                        <div class="col-xs-2">Type</div>
                        <div class="col-xs-2">Amount</div>
                    </div>
                    <div class="row"
                        *ngFor="let li of orderdetails.orderLineItems | lineItemsByProductSubType :  'MEMBERSHIP'">
                        <div class="col-xs-8">{{li.ProductName}}</div>
                        <div class="col-xs-2" *ngIf="li.ProductSubType == ProductSubType.NationalDues; else elseBlock">
                            National</div>
                        <ng-template #elseBlock>
                            <div class="col-xs-2">
                                <a [routerLink]="['/chapters']">Chapters</a>
                            </div>
                        </ng-template>
                        <div class="col-xs-2">{{ isRegYR123 ? 'INCLUDED' : li.UnitPrice |
                            currency:'USD':'symbol-narrow':'1.2-2'}}</div>
                    </div>
                </div>


                <div class="row optional-items checkoutCtr" *ngIf="orderdetails.orderLineItems">
                    <h3>Optional</h3>
                    <!-- <div class="row checkoutCtr">
            <div class="col-md-8">&nbsp;</div>
            <div class="col-md-2">&nbsp;</div>
            <div class="col-md-2">&nbsp;</div>
          </div> -->
                    <!-- [(ngModel)]="li.Selected" (ngModelChange)="changed($event)" -->
                    <div class="row"
                        *ngFor="let li of orderdetails.orderLineItems | lineItemsByProductSubType :  'OPTIONAL'">
                        <div class="col-xs-7 col-md-8">
                            <div class="checkboxWrap">
                                <input data-validate="false" id="{{li.ProductNumber}}" name="selectProduct"
                                    type="checkbox" [checked]="li.Selected" (change)="changed_optional_cb($event, li)">
                                <label for="{{li.ProductNumber}}">{{li.ProductName }}</label>
                            </div>

                            <div
                                class="primaryEmpName {{ ( (li.ProductSubType !=  ProductSubType.PAC) && (li.ProductSubType !=  ProductSubType.NEMPAC) ) || li.UnitPrice == 0 ? 'hidethis': ''}}">
                                <p>Please enter "N/A" if you are currently not employed.</p>
                                <div class="validationwrap">
                                    <input required class="form-control" type="text" name="pe_{{li.ProductNumber}}"
                                        placeholder="Enter Primary Employer Name" [(ngModel)]="li.PrimaryEmployer" (input)="syncPrimaryEmployerAcrossOptional($event.target.value)" >
                                    <div class="validationhead primaryEmpNameValidation">Required</div>




                                </div>

                            </div>


                        </div>
                        <div class="col-xs-2 col-md-2">
                            <a *ngIf="li.ProductSubType == ProductSubType.SECT" [routerLink]="['/sections']">Section</a>
                            <a *ngIf="li.ProductSubType == ProductSubType.ChapterDues"
                                [routerLink]="['/chapters']">Chapters</a> {{li.ProductNumber == 'EAAL' ||
                            li.ProductNumber == 'EEAL-MTHLY3YR' ? 'EMRA' : ''}}
                        </div>


                        <div class="col-xs-3 col-md-2"
                            *ngIf="!li.Modifiable || li.ProductSubType == ProductSubType.SECT ; else elsePriceBlock">{{(
                            (isRegYR123 && li.ProductNumber != 'EEAL-MTHLY3YR') ? 'FREE' : ( li.Selected ||
                            (li.ProductNumber == 'EAAL' ||
                            li.ProductNumber == 'EEAL-MTHLY3YR')? li.UnitPrice
                            : 0 )|
                            currency:'USD':'symbol-narrow':'1.2-2') }}</div>

                        <ng-template #elsePriceBlock>
                            <div class="col-xs-3 col-md-2">
                                $
                                <input class="pricebox numeric" type="text" name="proce_{{li.ProductNumber}}"
                                    [(ngModel)]="li.UnitPrice" [disabled]="!li.Selected"
                                    (ngModelChange)="changed($event)">
                                <!-- (blur)="updatePriceFormat()" -->

                            </div>
                        </ng-template>
                    </div>
                </div>



                <div class="row">
                    <h3>Checkout</h3>

                    <div class="row no-BootstrapCtr checkoutCtr FlowupLabels">

                        <div class="f100 clear" *ngIf="isEMRAProRateMode">
                            <div class="optionbtn promoCodebtn trialMembCtr">
                                <span class="trialMbrWrapper">{{cycleStartDate}} - {{cycleEndDate}}
                                    <br>
                                    <span class="wrapperAmount">{{ orderdetails.TotalAmount |
                                        currency:'USD':'symbol-narrow':'1.2-2'}}</span>
                                </span>
                            </div>
                        </div>

                        <!-- Graduating Residents Start -->
                        <div class="gr f100 clear" *ngIf="isGraduatingResidentOrFellow && !!gresOptions">
                            <h3>Payment Options</h3>
                            <div class="validationwrap">
                                <p class="validationhead">Please select one installment type from the following:</p>
                                <div class="radioBlock cartInstallments clear">

                                    <input type="radio" name="installments_GR" id="Monthly_GR" required="required"
                                        [value]="true" [(ngModel)]="isRegYR123"
                                        (ngModelChange)="changeGraduatingResidentRate()" />
                                    <label for="Monthly_GR">
                                        <span class="installmentWrapper">{{gresOptions[0].Title}}
                                            <br>
                                            <span class="installmentAmount">{{
                                                gresOptions[0].OrderDetails.TotalAmount |
                                                currency:'USD':'symbol-narrow':'1.2-2' }}</span>
                                            <br>
                                            <p [innerHTML]="gresOptions[0].Summary"></p>
                                        </span>
                                    </label>

                                    <input type="radio" name="installments_GR" id="NoInstallments_GR"
                                        required="required" [value]="false" [(ngModel)]="isRegYR123"
                                        (ngModelChange)="changeGraduatingResidentRate()" />
                                    <label for="NoInstallments_GR">
                                        <span class="installmentWrapper">{{gresOptions[1].Title}}
                                            <br>
                                            <span class="installmentAmount">{{ gresOptions[1].OrderDetails.TotalAmount |
                                                currency:'USD':'symbol-narrow':'1.2-2' }}</span>
                                            <p [innerHTML]="gresOptions[1].Summary"></p>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- Graduating Residents End -->

                        <payment #payment (updatePaymentSummary)="updatePaymentSummary($event)"
                            (OrderProcessingCompleted)="OrderProcessingCompleted($event)" [od]="orderdetails"
                            [pconfig]="paymentuiconfig">
                            <div class="payment-check-details">
                                <!--Please submit your checks to ACEP Technologies Services Dept....-->
                            </div>
                            <div class="payment-autorenewal-details">
                                <!--The subscription autorenews every year until you cancel!!!!-->
                            </div>
                        </payment>
                    </div>
                </div>

                <hr>

                <div class="row">
                    <h3>Terms & Conditions</h3>
                    <div class="checkoutCtr">
                        <div id='termsContent' [innerHtml]="termsAndConditionsText">
                        </div>
                        <div class="validationwrap">
                            <div class="checkboxWrap">
                                <input data-validate="true" id="agreeToTerms" name="saveCC" type="checkbox"
                                    required="required">
                                <label for="agreeToTerms">I agree to the above Terms & Conditions</label>
                                <span class="validationhead">Please agree to our Terms &amp; Conditions</span>
                            </div>
                        </div>
                    </div>
                </div>

                <hr>

                <div class="row actions">
                    <div class="col-xs-12">
                        <button *ngIf="payment.od.PaymentInformation.PaymentType != 5" mat-raised-button class="btnSave"
                            (click)="submitpayment($event)">Submit</button>
                        <div [hidden]="!(payment.od.PaymentInformation.PaymentType == 5 )" #paypal
                            (click)="submitpayment($event)"></div>
                    </div>
                </div>

            </form>

        </div>
    </div>

</div>

<!-- <pre>
    <code>

        PAYMENT SERVICE: ORDER DETAILS
        {{paymentservice.orderdetails | json}}

    </code>
  </pre>  -->